import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';
import CouponApiConstants from './CouponApiConstants';
import { RestConfig, getHostConfig } from '../Common/RestConfig';

const {
    BEST_COUPON_SERVICE_URL,
    EXP_COM_COUPON_SERVICE_URL,
    BEST_COUPON_SERVICE_URL_AURORA,
} = CouponApiConstants;
const types = [];
/* eslint-disable */
types['Omnichannel'] = 'ONLINE_AND_IN_STORE';
types['StoreOnly'] = 'IN_STORE_ONLY';
types['OnlineOnly'] = 'ONLINE_ONLY';


/** getActiveCoupons :: Filters Active Coupons */
const getActiveCoupons = (json) => {
    const validCouponData = json.data; // Avoids mutation of original data
    validCouponData.status = json.status;

    let numCoupons = 0; // num Coupons

    const validCoupons = json.data.groups.map((group) => {
        const activeCoupons = group.coupons.filter(
            activeStatus => activeStatus.expired === false,
        );

        numCoupons += activeCoupons.length;
        group.coupons = activeCoupons; // Only Active coupons push
        return group;
    });

    validCouponData.groups = validCoupons;
    validCouponData.numCoupons = numCoupons; // Adding Total Aggregate coupons for covering Edge case scenario

    // Picking required data from Response headers
    /* istanbul ignore if  */
    if (__SERVER__) {
        validCouponData.CacheControl = json && json.headers && json.headers._headers && json.headers._headers['x-yoda-cache-control']; // No Fall back.
    }

    return validCouponData;
};

const transform = (json) => {
    const groups = json.data.groups;
    const couponTransformed = [];
    groups.forEach((couponsFinal) => {
        couponsFinal.coupons.map(coupon => couponTransformed.push(coupon));
    });

    // console.log('Coupon Transformed', couponTransformed);
    const transformedCoupons = couponTransformed.map((couponObj) => {
        // TODO :: Need to check whether this increases the performence.
        // doesn't want to inherit the prototypical chain methods, if required then can be used directly
        // let channelObj = Object.create(null);
        // channelObj.name = couponObj.channel.message;
        // channelObj.type =  couponObj.channel.code;
        let linksObj = couponObj.links;

        Object.keys(linksObj).forEach((key) => {
            if (linksObj[key].href === null) {
                delete linksObj[key];
            } else {
                linksObj[key].label = linksObj[key].title;
                delete linksObj[key].title;
                if (linksObj[key] && linksObj[key].rel === 'details') { linksObj[key].label = 'print'; }
            }
        });

        linksObj = linksObj.filter((e) => { return e }); // removing undefined objects because of delete.


        const channelObj = { name: couponObj.channel.message, type: types[couponObj.channel.code] };
        const offerObj = [{ data: couponObj.offers, links: linksObj }];

        return {
            name: couponObj.name,
            code: couponObj.code,
            channel: channelObj,
            disclaimerText: couponObj.disclaimer,
            validTil: couponObj.validTill,
            offers: offerObj,
            applied: false,
            expired: false,
            bestCoupon: false,
            totalDiscount: 0,
        };
    });


    /** filtering coupons by categories - Removing for supporting ordering, May need to do related changes in ApplyCouponInput */
    // const onlineOrStoreCoupons = transformedCoupons.filter( (item) => { return (item.channel.type === 'ONLINE_AND_IN_STORE' || item.channel.type === 'ONLINE_ONLY') });
    // const InstoreOnly = transformedCoupons.filter( (item) => { return (item.channel.type === 'IN_STORE_ONLY') });

    /** Final Transformed coupon List in groups object */
    var finalTransformedCoupon = [{
        id: 'ONLINEORSTORECOUPONS',
        coupons: transformedCoupons,
    }];

    const copyText = '<h2>JCPenney Coupons Let Everyone Enjoy Huge Savings</h2> <p>Prepare for incoming savings! Now, you can enjoy our full range of coupons here at JCPenney! Whether you are planning on a shopping trip in-store or hunkering down for a therapeutic online shopping session, full access to JCPenney promo codes along with in-store coupons or online discounts can be found right here!</p> <h2>A Streamlined Shopping Experience with Online Coupons</h2> <p>Everyone loves free shipping. That is why we will put any of our shipping offers right here for you to enjoy. Be sure to take advantage of our special online deals on different departments since we are always rolling out exciting new deals and promotions on all of your favorite items! Check back here often to stay on top of all the latest JCPenney promo codes such as salon coupons and more!</p> <p>Looking for even more ways to save? Apply today for a <a href="https://www.onlinecreditcenter6.com/eapplygen2/load.do?cHash=1342177401&subActionId=1000">JCPenney credit card </a> and enjoy cardholder-exclusive offers and rewards as well as 15% off your initial purchase (5% off major appliances when you open and use your JCPenney credit card). Even better, our <a href="http://www.jcpenney.com/g/sales-deals/N-1b0cnoo?pageType=X2H2">sales</a> and <a href="http://www.jcpenney.com/g/clearance/N-1aznsmx">clearance</a> pages contain a bevy of great products at even better prices. Who knows what you will find next, so roll up your sleeves and get ready to dive into a whole new world of easy savings with JCPenney coupons!</p>';

    const validCouponData = {};
    validCouponData.groups = finalTransformedCoupon;
    validCouponData.status = json.status;
    validCouponData.numCoupons = couponTransformed.length;
    validCouponData.seoTitleTags = {
        seoMetaTitle: 'JCPenney Coupons & Promo Codes',
        seoMetaKeyword: 'Coupon, Jcpenney Coupon, Offers',
        seoMetaDescription: 'Huge savings & FREE SHIPPING available when you use JCPenney online coupons & promo codes. Save on apparel, window, home decor & more!',
        h1Data: 'jcpenney coupons',
        searchTerms: '',
        canonicalURL: '/m/jcpenney-coupons/N-mpi6e5',
        copyText,
        noIndexNoFollowRequired: false,
    };

    return validCouponData;
};

const getActiveUnmergedCoupons = params => RestClient.get({ url: EXP_COM_COUPON_SERVICE_URL, version: '/v4', params })
    .then(json => transform(json))
    .catch(error => ({
        status: 500,
        error,
    }));
//Changing the version for best coupons legacy adapater API to work on the dotcom channel, anyways V2 works for both m.dot and dotcom. Please don't change the version.
const getActiveBestCoupons = params => RestClient.get({ url: BEST_COUPON_SERVICE_URL, version: '/v2', params })
    .then(json => getActiveCoupons(json))
    .catch(error => ({
        status: 500,
        error,
    }));


const getActiveBestCouponsAurora = params => {
    let url = BEST_COUPON_SERVICE_URL_AURORA;
    url = `accounts/${params.accountId}/${BEST_COUPON_SERVICE_URL_AURORA}`;
    let config = RestConfig.v1DraftConfig();
    config = getHostConfig(config);
    config.version = '/order-api/v2';
    config.url = url;
    config.accessToken = params.accessToken;
    if (params.clientId) {
        config.xClientId = params.clientId;
    }
    config.params = { expand: params.expand, mediaCode: params.mediaCode };
    config.xClientSource = params.xClientSource;
    if (params.isCheckout) {
        config.params.origin="CHECKOUT";
    }
    return RestClient.get(config)
        .then(response => response);
};

/**
 * @param priceFlag {false} default case (no items in cart).
 * @param priceFlag {true} (items present in cart)
 * @param marketing {barcodeusage} (gives the marketing channel user comes from)
 */
export const getCouponList = (priceFlag = false, marketing = null, unmerged = false, isCheckout = false) => {


    // Taking Params depending on condn.
    const pricingParam = (priceFlag) ? (isCheckout ? { expand: 'review' } : { expand: 'pricing' }) : ''; // checking whether price expansion param is there
    let marketingParam = (marketing) ? { mediaCode: marketing } : '';  // checking whether marketing param is there

    // Merging in to a single object.
    let params = Object.assign({}, pricingParam, marketingParam);

    if (unmerged) {
        marketingParam = (marketing) ? { context: marketing } : '';
        params = Object.assign({}, pricingParam, marketingParam); // merging different params based on issues.
        return getActiveUnmergedCoupons(params);
    }

    return getActiveBestCoupons(params);
};
export const getCouponListAurora = (postData = {}) => {
    const pricingParam = postData.payload && postData.payload.priceFlag ? { expand: 'pricing' } : '';
    const marketingParam = postData.payload && postData.payload.marketing ? { mediaCode: marketing } : '';
    const params = Object.assign({}, pricingParam, marketingParam, postData.accountId);
    params.accountId = postData.accountId;
    params.accessToken = postData.accessToken;
    if (postData.payload && postData.payload.clientId) {
        params.clientId = postData.payload.clientId;
    }
    if (postData.payload && postData.payload.isCheckout) {
        params.isCheckout = postData.payload.isCheckout;
    }
    if (postData.payload && postData.payload.xClientSource) {
        params.xClientSource = postData.payload.xClientSource;
    }
    return getActiveBestCouponsAurora(params);
};

/**
 * Function to fetch couponDetails modal content for PDP.
 */
export const getCouponTiles = () => {
    const context = RestClient.getContext() || {};
    const config = {
        apiHost: apiHosts.content,
        url: context.isPreview ? '/prvcontent-api/content/couponTile' : '/content-api/content/couponTile',
        external: false,
        excludeVersion: true,
    };

    /* istanbul ignore next */
    return RestClient.get(config)
        .then(json => json.data).catch((error) => {
            console.log(`request failed ${error}`);
        });
};
